import React from 'react';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';

const APIDocs = () => {
  return (
    <SwaggerUI url="/docs/api.yaml" />
  );
};

export default APIDocs;
